import(/* webpackMode: "eager", webpackExports: ["StateProvider"] */ "/app/app/(chat)/chat/context/generalReducer.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["SocketProvider"] */ "/app/app/(chat)/chat/context/SocketContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager" */ "/app/styles/globals.css");
